import { Component, Input } from '@angular/core';
import { ManipulativeType } from 'app/question/constants/manipulative-type.enum';
import { QuestionAnswerType } from 'app/question/constants/question-answer-type';
import * as questionUtils from 'app/question/utils/question-utils';
@Component({
    selector: 'kh-tq-answers-header',
    templateUrl: './tq-answers-header.component.html',
    styleUrls: ['./tq-answers-header.component.less'],
    standalone: false
})
export class TqAnswersHeaderComponent {
  public utils = questionUtils;

  @Input() public showFullList = false;
  @Input() public answerType!: QuestionAnswerType;
  @Input() public manipulativeType!: ManipulativeType;

  public isMultipleChoice(): boolean {
    return this.answerType === QuestionAnswerType.MultipleChoiceAnswers;
  }

  public isMultipleSelect(): boolean {
    return this.answerType === QuestionAnswerType.MultiSelectAnswers;
  }

  public isArrangeInOrder(): boolean {
    return this.answerType === QuestionAnswerType.ArrangeInOrder;
  }

  public isManipulative(): boolean {
    return this.utils.isManipulative(this.answerType, this.manipulativeType)
      || this.utils.isImageSwap(this.answerType, this.manipulativeType)
  }
}
